//       Men..................................................................
      jQuery(document).ready(function(){

jQuery('.sidebar h5.ipsum').click(function(){
jQuery(this).parents('.collaps').toggleClass('hide_class');
jQuery('.filter-menu .collaps').not(jQuery(this).parents('.collaps')).addClass('hide_class');
});


        if($(window).width() < 767){


jQuery('nav.wsmenu > ul > li.hov_sub, nav.wsmenu > ul > li.hov_sub1, nav.wsmenu > ul > li.hov_sub2, nav.wsmenu > ul > li.hov_sub4').append('<span class="arr_g"></span>');
jQuery('nav.wsmenu > ul > li').each(function(i){
jQuery(this).find('span.arr_g').addClass('baa_'+i);

});

jQuery('.baa_0').click(function(){
// alert('click');
jQuery('.mainsub').slideToggle();
});
jQuery('.baa_1').click(function(){
jQuery('.mainsub1').slideToggle();
});
jQuery('.baa_3').click(function(){
jQuery('.mainsub2').slideToggle();
});
jQuery('.baa_4').click(function(){
jQuery('.mainsub11').slideToggle();
});

}

});

      
      if ($(window).width() > 767) {
$(document).ready(function(){


   


    $(".hov_sub").mouseover(function(){
        $('.mainsub').css("display", "block");
        
    });
});
      
      
      $(document).ready(function(){
    $(".hov_sub").mouseout(function(){
        $('.mainsub').css("display", "none");
        
    });
});
      
      $(document).ready(function(){
    $(".mainsub").mouseover(function(){
        $('.mainsub').css("display", "block");
        
    });
});
      
      
      $(document).ready(function(){
    $(".mainsub").mouseout(function(){
        $('.mainsub').css("display", "none");
        
    });
});
      
//       women................................................................
      
      
      $(document).ready(function(){
    $(".hov_sub1").mouseenter(function(){
        $('.mainsub1').css("display", "block");
        
    });
});
      
      
      $(document).ready(function(){
    $(".hov_sub1").mouseleave(function(){
        $('.mainsub1').css("display", "none");
        
    });
});
      
      
      $(document).ready(function(){
    $(".mainsub1").mouseover(function(){
        $('.mainsub1').css("display", "block");
        
    });
});
      
      
      $(document).ready(function(){
    $(".mainsub1").mouseout(function(){
        $('.mainsub1').css("display", "none");
        
    });
});
      
      
//     sports.................................  
      
      $(document).ready(function(){
    $(".hov_sub2").mouseenter(function(){
        $('.mainsub2').css("display", "block");
        
    });
});
      
      
      $(document).ready(function(){
    $(".hov_sub2").mouseleave(function(){
        $('.mainsub2').css("display", "none");
        
    });
});
      
      
      
      
      $(document).ready(function(){
    $(".mainsub2").mouseover(function(){
        $('.mainsub2').css("display", "block");
        
    });
});
      
      
      $(document).ready(function(){
    $(".mainsub2").mouseout(function(){
        $('.mainsub2').css("display", "none");
        
    });
});
      
      
      
//       kids..............................................
      $(document).ready(function(){
    $(".hov_sub3").mouseenter(function(){
        $('.mainsub3').css("display", "block");
        
    });
});
      
      
      
       $(document).ready(function(){
    $(".hov_sub3").mouseleave(function(){
        $('.mainsub3').css("display", "none");
        
    });
});
      
      
      
      
      $(document).ready(function(){
    $(".mainsub3").mouseover(function(){
        $('.mainsub3').css("display", "block");
        
    });
});
      
      
      $(document).ready(function(){
    $(".mainsub3").mouseout(function(){
        $('.mainsub3').css("display", "none");
        
    });
});
      
    
      $(document).ready(function(){
    $(".hov_sub4").mouseover(function(){
        $('.mainsub11').css("display", "block");
        
    });
});
      
      
      $(document).ready(function(){
    $(".hov_sub4").mouseout(function(){
        $('.mainsub11').css("display", "none");
        
    });
});
      
      
      $(document).ready(function(){
    $(".mainsub11").mouseover(function(){
        $('.mainsub11').css("display", "block");
        
    });
});
      
      
      $(document).ready(function(){
    $(".mainsub11").mouseout(function(){
        $('.mainsub11').css("display", "none");
        
    });
});
      
    }